<nz-card class="setup-summary-card">
  <div class="setup-summary">
    <div class="header">
      <div class="title">
        <strong>Setup summary</strong>
        @if (collapsedTitle() && collapsed()) {
          <strong> {{ collapsedTitle() }}</strong>
        }
      </div>
      @if (showToggle()) {
        <button nz-button nzType="link" (click)="toggle()">
          <span nz-icon [nzType]="toggleIcon()" nzTheme="outline"></span>
          {{ toggleLabel() }}
        </button>
      }
    </div>

    @if (!showToggle() || !collapsed()) {
      <div class="setup-summary-content">
        <ng-content />
      </div>
    }
  </div>
</nz-card>
